module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_calendar-d2e2b5c697bc0ec11850dbe7b80adc3c.svg";